import { Badge } from "@/components";
import { useAuthStore } from "@/state/auth.store";
import { useLang } from "@/i18n/LanguageContext";
import { roleLabel } from "@/features/users/roles";
import { ProgramPage } from "@/features/program/ProgramPage";
import { TenantsPanel } from "./TenantsPanel";
import { UsersPanel } from "./UsersPanel";
import { DashboardOverview } from "./DashboardOverview";

export function DashboardPage() {
  const { t } = useLang();
  const user = useAuthStore((s) => s.user);
  if (!user) return null;

  // Employees land directly on their personalized program.
  if (user.role === "employee") return <ProgramPage />;

  return (
    <section>
      <div className="wrap">
        <div className="section-head">
          <p className="eyebrow">Dashboard</p>
          <h2>{t("Hallo", "Hi")} {user.full_name || user.email}</h2>
          <p style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <Badge tone="ok">{roleLabel(user.role, t)}</Badge>
            {user.tenant_id ? <Badge>{t("tenant actief", "tenant active")}</Badge> : <Badge tone="warn">{t("platform-niveau", "platform level")}</Badge>}
          </p>
        </div>

        {user.role === "platform_admin" && <TenantsPanel />}

        {(user.role === "org_admin" || user.role === "manager") && (
          <>
            <DashboardOverview isOrgAdmin={user.role === "org_admin"} />
            <UsersPanel canCreate={user.role === "org_admin"} />
          </>
        )}
      </div>
    </section>
  );
}
